import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { getTreatments, updateTreatments } from "../../../../apis/treatment";
import { toastify } from "../../../../helperFunctions/toastify";
import {
	customNumberSort,
	customStringSort,
	exportData,
} from "../../../../helperFunctions/utils";
import DeleteModal from "../../../SharedComponents/DeleteModal";
import FilterComponent from "../../../SharedComponents/FilterComponent";

export default function Treatments() {
	const navigate = useNavigate();
	const [treatments, setTreatments] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [show, setShow] = useState(false);
	const [deleting, setDeleting] = useState("");

	const handleClose = () => {
		setShow(false);
		setDeleting("");
	};

	const getTreatmentsList = async () => {
		const response = await getTreatments();
		if (response?.status !== "Fail") {
			setTreatments(response.reverse());
		} else {
			if (response?.message === "No data Found") {
				setTreatments([]);
			} else {
				toastify(response?.message, "error");
			}
		}
	};

	const removeTreatment = async () => {
		setShow(false);
		let response = await updateTreatments(deleting, { isDeleted: true });
		if (response?.status !== "Fail") {
			getTreatmentsList();
			toastify("Treatment deleted successfully!", "success");
		} else {
			toastify(response?.message, "error");
		}
	};

	const editUom = (e) => {
		navigate("/add-inventory-treatments", {
			state: {
				treatment: e,
			},
		});
	};

	const addUom = () => {
		navigate("/add-inventory-treatments");
	};

	useEffect(() => {
		getTreatmentsList();
	}, []);

	const columns = [
		{
			name: "Code",
			selector: (row) => row.code,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "code"),
		},
		{
			name: (
				<div className="d-flex align-items-center" id="ovly28">
					<span className="me-2">Name</span>
					{
						<FilterComponent
							type="search"
							array={treatments}
							setArray={setFilteredData}
							value="Name"
						/>
					}
				</div>
			),
			selector: (row) => row.name,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "name"),
		},
		{
			name: "Treatment Type",
			selector: (row) => row.tagButtons,
		},
		{
			name: "Price",
			selector: (row) => row.price?.toLocaleString(),
			sortable: true,
			sortFunction: (a, b) => customNumberSort(a, b, "price"),
		},
		{
			name: "Action",
			selector: (row) => row.action,
		},
	];

	const data = (filteredData.length === 0 ? treatments : filteredData)?.map(
		(e, index) => {
			return {
				id: e._id,
				name: e.name,
				price: e.price,
				code: e.code,
				consents: e.consents,
				index: index,
				description: e.description,
				tag: e?.tag?.name,
				tagButtons: (
					<div
						className="rounded-button"
						style={{ width: 110, background: e?.tag?.color }}
					>
						{e?.tag?.name?.length > 9
							? e?.tag?.name?.substring(0, 6) + "..."
							: e?.tag?.name}
					</div>
				),
				action: (
					<div className="d-flex">
						<div
							className="mx-3  cursor-pointer icon-width"
							onClick={() => {
								editUom(e);
							}}
						>
							<i className="fa fa-pen"></i>
						</div>
						<div
							className="mx-3  cursor-pointer icon-width"
							onClick={() => {
								setDeleting(e._id);
								setShow(true);
							}}
						>
							<i className="fa fa-trash"></i>
						</div>
					</div>
				),
			};
		},
	);

	const customStyles = {
		headCells: {
			style: {
				justifyContent: "center",
			},
		},
		cells: {
			style: {
				justifyContent: "center",
				textAlign: "center",
			},
		},
	};

	const conditionalRowStyles = [
		{
			when: (row) => row,
			style: {
				borderWidth: "0px",
			},
		},
		{
			when: (row) => row.index % 2 === 1,
			style: {
				borderWidth: "0px",
				backgroundColor: "#f8f8f8",
			},
		},
	];

	return (
		<>
			<div className="container p-0">
				<div className="mainHeading px-4">
					<h1>Treatments</h1>
					<div className="d-flex">
						<Button
							className="addItem me-3"
							onClick={() => {
								const tempDataArr = data?.map((e) => {
									return {
										Code: e.code,
										Name: e.name,
										Price: e.price,
										Description: e.description,
									};
								});
								exportData(tempDataArr, "Treatments");
							}}
						>
							Export
						</Button>
						<Button className="addItem" onClick={addUom}>
							+ Add New
						</Button>
					</div>
				</div>

				<DeleteModal
					content="Confirm Treatment Deletion?"
					onYes={removeTreatment}
					onNo={handleClose}
					show={show}
				/>

				<DataTable
					columns={columns}
					customStyles={customStyles}
					data={data || []}
					pagination
					conditionalRowStyles={conditionalRowStyles}
				/>
			</div>
		</>
	);
}
